import { signUpTextStyling } from "@components/Login/LoginForm";
import { NewUserPlaceholder } from "@components/NewUserPlaceholder";
import { css } from "@emotion/react";
import React, { useState } from "react";

import { IdentityProvider } from "@every.org/common/src/codecs/auth";
import {
  getRoutePath,
  URLFormat,
  ClientRouteName,
} from "@every.org/common/src/helpers/clientRoutes";

import { Button, ButtonRole, ButtonTargetKind } from "src/components/Button";
import { Link } from "src/components/Link";
import { Modal } from "src/components/Modal";
import { EmailSignupForm } from "src/components/Signup/EmailSignupForm";
import { SocialLoginButton } from "src/components/SocialLoginButton";
import { LinkAppearance } from "src/styles/link";
import { MediaSize, cssForMediaSize } from "src/theme/mediaQueries";
import {
  horizontalStackCss,
  spacing,
  verticalStackCss,
} from "src/theme/spacing";
import { textSizeCss } from "src/theme/text";

const SIGNUP_IMAGE_HEIGHT = 230;
const SIGNUP_IMAGE_WIDTH = 281;
const SIGNUP_FORM_CONTAINER_WIDTH = 400;

const buttonFormStyleCss = css`
  width: 100%;
`;

export const SignupModal: React.FCC<{
  redirectUrl?: string;
  title?: string;
  isModalOpen?: boolean;
}> = ({ redirectUrl, title, isModalOpen = false }) => {
  const [isSignUpEmail, setIsSignUpEmail] = useState(false);

  return (
    <Modal isOpen={isModalOpen}>
      <h2 css={textSizeCss.xl}>{title}</h2>
      <section
        css={[
          cssForMediaSize({
            min: MediaSize.LARGE,
            css: horizontalStackCss.xxxl,
          }),
        ]}
      >
        <div
          css={[
            css`
              margin-top: ${spacing.xxl};
              width: ${SIGNUP_FORM_CONTAINER_WIDTH}px;
            `,
            cssForMediaSize({
              max: MediaSize.MEDIUM,
              css: css`
                width: 100%;
                margin-top: ${spacing.l};
              `,
            }),
          ]}
        >
          {isSignUpEmail ? (
            <EmailSignupForm redirectUrl={redirectUrl} isModal />
          ) : (
            <section css={[verticalStackCss.xxl]}>
              <div css={[verticalStackCss.s]}>
                <SocialLoginButton
                  idp={IdentityProvider.GOOGLE}
                  css={buttonFormStyleCss}
                  data-tname="signupGoogle"
                  redirectUrl={redirectUrl}
                />
                <Button
                  data-tname="signupEmail"
                  onClick={{
                    kind: ButtonTargetKind.FUNCTION,
                    action: () => setIsSignUpEmail(true),
                  }}
                  role={ButtonRole.TEXT_ONLY}
                  contentCss={signUpTextStyling}
                >
                  <span>or sign up with email</span>
                </Button>
              </div>
              <p>
                Already have an account?{" "}
                <Link
                  appearance={LinkAppearance.HYPERLINK}
                  data-tname="loginSignupmodal"
                  target="login"
                  to={getRoutePath({
                    format: URLFormat.RELATIVE,
                    name: ClientRouteName.LOGIN,
                  })}
                >
                  Log in
                </Link>
              </p>
            </section>
          )}
        </div>
        <NewUserPlaceholder
          width={SIGNUP_IMAGE_WIDTH}
          height={SIGNUP_IMAGE_HEIGHT}
          margin={spacing.xl}
          hideSize={MediaSize.LARGE}
        />
      </section>
    </Modal>
  );
};
